import { queryOptions, useQuery } from '@tanstack/react-query'
import { apiFetch } from '@shared/api/http'
import { CurrentUserSchema } from './user.contract'
import type { CurrentUser } from './user.contract'

export const userKeys = {
  me: ['user', 'me'] as const,
}

export async function getCurrentUser(): Promise<CurrentUser> {
  const data = await apiFetch<unknown>('/users/me')
  return CurrentUserSchema.parse(data)
}

export function currentUserQuery(enabled = true) {
  return queryOptions({
    queryKey: userKeys.me,
    queryFn: getCurrentUser,
    enabled,
  })
}

export function useCurrentUserQuery(enabled = true) {
  return useQuery(currentUserQuery(enabled))
}
